import { notRequired } from '@jfs/ui-new/src/utils/validations'
import { Dropdown } from '../../components/Dropdown'
import { useStores } from '../../data/store'
import { MethodSubTypeDropdown } from './MethodSubTypeDropdown'

const subTypeData = [
  { id: 1, value: '581-Netbanking' },
  { id: 2, value: '582-Card' },
  { id: 3, value: '566-UPI' },
  { id: 4, value: '579-Wallet' },
]
const methodTypeData = [
  { id: 1, value: '110-Purchase' },
  { id: 2, value: '112-Refund' },
]

const cardTypeData = [
  { id: 110, value: 'Debit' },
  { id: 130, value: 'Credit' },
  { id: 131, value: 'Pre-paid' },
  { id: 140, value: 'FoodCard' },
  { id: 5, value: 'NA' },
]

export const GetFormdata: any = (onSearch: any, selectedInstrument: any, cardType: any) => {
  const { bankList, walletList, cardList, entityData } = useStores((store) => ({
    bankList: store.routingRule.bankList,
    walletList: store.routingRule.walletList,
    cardList: store.routingRule.cardList,
    entityData: store.routingRule.getEntityData(),
  }))

  console.log('entityData', entityData)
  const selectedInstrumentList = (selectedInstrument.includes('Wallet') ? walletList : bankList).map((item) => {
    return { ...item, value: item.name }
  })

  const bankDependencyValues = subTypeData
    .map((item) => {
      if (item.value.includes('Netbanking') || item.value.includes('Wallet')) {
        return item.value
      }
    })
    ?.filter((item) => item !== undefined && item !== 'NA')

  const cardSchemeDependencyValues = cardTypeData
    .map((item) => {
      if (item.value != 'NA') {
        return item.value
      }
    })
    ?.filter((item) => item !== undefined && item !== 'NA')
  const bankCardDependencyValues = subTypeData
    .map((item) => {
      if (item.value.includes('Card')) {
        return item.value
      }
    })
    ?.filter((item) => item !== undefined && item !== 'NA')
  // console.log('bankDependencyValues', bankDependencyValues, bankCardDependencyValues, cardSchemeDependencyValues)
  const cardTypeScheme = cardTypeData.find((data) => data?.value === cardType)?.id
  const cardSchemeData = cardList
    .filter((card) => card.type == cardTypeScheme)
    .map((card) => ({ ...card, value: card.description }))
  return [
    {
      formItems: [
        {
          horizontalComps: [
            {
              fieldName: 'processingEntity',
              ComponentName: Dropdown,
              title: 'Processing Entity',
              label: 'Processing Entity',
              validationSchema: notRequired,
              data: entityData,
              showResetSelection: true,
            },
            {
              fieldName: 'methodSubType',
              ComponentName: MethodSubTypeDropdown,
              title: 'Method Sub Type',
              label: 'Method Sub Type',
              validationSchema: notRequired,
              data: subTypeData,
              showResetSelection: true,
            },
            {
              fieldName: 'methodType',
              ComponentName: Dropdown,
              title: 'Method Type',
              label: 'Method Type',
              validationSchema: notRequired,
              data: methodTypeData,
              showResetSelection: true,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'bankId',
              ComponentName: Dropdown,
              title: selectedInstrument.includes('Wallet') ? 'Wallet' : 'Bank',
              label: selectedInstrument.includes('Wallet') ? 'Wallet' : 'Bank',
              validationSchema: notRequired,
              data: selectedInstrumentList,
              dependency: ['methodSubType', bankDependencyValues],
              showResetSelection: true,
            },
            {
              fieldName: 'cardType',
              ComponentName: Dropdown,
              title: 'Card Type',
              label: 'Card Type',
              validationSchema: notRequired,
              data: cardTypeData,
              dependency: ['methodSubType', bankCardDependencyValues],
              showResetSelection: true,
            },
            {
              fieldName: 'cardScheme',
              ComponentName: Dropdown,
              title: 'Card Scheme',
              label: 'Card Scheme',
              validationSchema: notRequired,
              data: cardSchemeData,
              dependency: ['methodSubType', bankCardDependencyValues],
              showResetSelection: true,
            },
          ],
        },
      ],
      horizontalFlex: 1,
      onSubmit: async (values: any) => {
        console.log('values =', values)
        onSearch({
          methodSubType: values.methodSubType.split('-')[0].trim(),
          methodType: values.methodType.split('-')[0].trim(),
          bankId: selectedInstrumentList.find((data) => data?.name === values.bankId)?.id,
          processingEntity: entityData.find((data) => data?.value === values.processingEntity)?.id,
          cardScheme: cardSchemeData.find((data) => data?.value === values.cardScheme)?.scheme,
          cardType: cardTypeData.find((data) => data?.value === values.cardType)?.id,
        })
        return 'end'
      },
      actionTitle: 'Search',
    },
  ]
}
